<template>
  <div class="feet-r">
    <el-button
      icon="el-icon-download"
      size="small"
      type="primary"
      :loading="loading"
      @click="operationBtn()"
    >{{ $t('receivablePayable.DownloadTheTemplate') }}</el-button>
    <upload-excel
      :on-success="importLogistics"
      :but-name="$t('receivablePayable.ImportCalculatePrices')"
    />
  </div>
</template>

<script>

const ExcelJS = require('exceljs');
import { saveAs } from 'file-saver';
import { TRANSPORTATION_TYPE } from '@/views/finance/utils';
import uploadExcel from '@/components/UploadExcel';
import toolRequestClass from '@/views/finance/mixins/toolRequestClass';
const columns = [
  {
    header: '运输单号',
    key: 'transportNumber',
    width: 40
  },
  {
    header: '车辆类型',
    key: 'vehicleType',
    width: 40
  },
  {
    header: '应付主体',
    key: 'providerId',
    width: 40
  },
  {
    header: '车线名称',
    key: 'lineId',
    width: 40
  },
  {
    header: '运输类型',
    key: 'routeType',
    width: 40
  },
  {
    header: '总里程（KM）',
    key: 'kilometers',
    width: 40
  },
  {
    header: '车签号',
    key: 'tagNumber',
    width: 40
  },
  {
    header: '实际出发时间(格式：2022-01-01 00:00:00)',
    key: 'actualDepartureTime',
    width: 40
  },
  {
    header: '实际达到时间(格式：2022-01-01 00:00:00)',
    key: 'actualArrivalTime',
    width: 40
  }
];
export default {
  components: {
    uploadExcel
  },
  mixins: [toolRequestClass],
  data() {
    return {
      TRANSPORTATION_TYPE,
      loading: false
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      await this.getTransportationProviderPage();
      await this.getApiOptionForSelect();
      await this.getApiCarLineDispatchSystemList();
    },
    getHeader() {
      const wb = new ExcelJS.Workbook();
      const Sheet1 = wb.addWorksheet('Sheet1');
      const Sheet2 = wb.addWorksheet('Sheet2');
      const Sheet3 = wb.addWorksheet('Sheet3');
      const Sheet4 = wb.addWorksheet('Sheet4');
      const Sheet5 = wb.addWorksheet('Sheet5');
      Sheet1.columns = columns;
      Sheet1.getCell('A2').value = 'Número do Pedido de Transporte';
      Sheet1.getCell('B2').value = 'Tipo de veículo';
      Sheet1.getCell('C2').value = 'Entidade a Paga';
      Sheet1.getCell('D2').value = 'Nome da Rota';
      Sheet1.getCell('E2').value = 'Tipo de Transport';
      Sheet1.getCell('F2').value = 'Quilometragem Total';
      Sheet1.getCell('G2').value = 'GlobalSetObj.NIV';
      Sheet1.getCell('H2').value = 'Tempo Real de Partida';
      Sheet1.getCell('I2').value = 'Tempo Real de Chegada';
      Sheet1.getRow(1).font = {
        color: { argb: '000000' },
        bold: true
      };
      Sheet1.getRow(2).font = {
        color: { argb: '000000' },
        bold: true
      };
      Sheet1.mergeCells('A3:C3');
      Sheet1.getCell('A3').value = '提示:运输单号字段必填,其他字段若维护了信息则代表需要更新该字段数据,数据最大导入上限10W行\n' +
        'Campo do número do documento de transporte é obrigatório;para os demais campos, se houver informações cadastradas, significa que os dados desses campos precisam ser\n' +
        'atualizados. O limite máximo de importaçãode dados é de 100.000 linhas.';
      Sheet1.getRow(3).height = 60;
      Sheet1.getRow(3).getCell(1).style = {
        font: {
          color: { argb: 'ff0000' }
        },
        alignment: {
          vertical: 'bottom', // 垂直居中
          horizontal: 'left', // 水平左对齐
          wrapText: true, // 自动换行
          indent: 0 // 禁止缩进
        }
      };
      Sheet2.columns = [{
        header: '车辆类型',
        key: 'vehicleType',
        width: 40
      }];
      const Sheet2_data = [];
      if (this.modelList && this.modelList.length > 0) {
        this.modelList.forEach((item) => {
          const { dictLabel, dictValue } = item;
          Sheet2_data.push({
            vehicleType: `${dictLabel}->${dictValue}`
          });
        });
      }
      Sheet2.addRows(Sheet2_data);
      Sheet3.columns = [{
        header: '应付主体',
        key: 'providerId',
        width: 40
      }];
      const Sheet3_data = [];
      if (this.transportationProviderList && this.transportationProviderList.length > 0) {
        this.transportationProviderList.forEach((item) => {
          const { providerName, id } = item;
          Sheet3_data.push({
            providerId: `${providerName}->${id}`
          });
        });
      }
      Sheet3.addRows(Sheet3_data);
      Sheet4.columns = [{
        header: '车线名称',
        key: 'lineId',
        width: 40
      }];
      const Sheet4_data = [];
      if (this.stitchingLine && this.stitchingLine.length > 0) {
        this.stitchingLine.forEach((item) => {
          const { name, id } = item;
          Sheet4_data.push({
            lineId: `${name}->${id}`
          });
        });
      }
      Sheet4.addRows(Sheet4_data);
      Sheet5.columns = [{
        header: '运输类型',
        key: 'routeType',
        width: 40
      }];
      const Sheet5_data = [];
      for (const item in TRANSPORTATION_TYPE) {
        const { label, value } = TRANSPORTATION_TYPE[item];
        Sheet5_data.push({
          routeType: `${label}->${value}`
        });
      }
      Sheet5.addRows(Sheet5_data);
      new Array(100000).fill(0).forEach((_, idx) => {
        const row = idx + 3;

        // 车型
        Sheet1.getCell(row, 2).dataValidation = {
          type: 'list',
          formulae: [`=Sheet2!$A$2:$A${Sheet2_data.length + 1}`]
        };
        // 主体
        Sheet1.getCell(row, 3).dataValidation = {
          type: 'list',
          formulae: [`=Sheet3!$A$2:$A${Sheet3_data.length + 1}`]
        };
        // 车线
        Sheet1.getCell(row, 4).dataValidation = {
          type: 'list',
          formulae: [`=Sheet4!$A$2:$A${Sheet4_data.length + 1}`]
        };
        // 运输类型
        Sheet1.getCell(row, 5).dataValidation = {
          type: 'list',
          formulae: [`=Sheet5!$A$2:$A${Sheet5_data.length + 1}`]
        };

        Sheet1.getCell(row, 8).numFmt = '@';
        Sheet1.getCell(row, 9).numFmt = '@';
      });
      return wb;
    },
    // 下载模板
    async operationBtn() {
      this.loading = true;
      try {
        const wb = this.getHeader();
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/octet-stream'
        });
        const saveName = this.$t('receivablePayable.updateDataRecalculatePrice') + '.xlsx';
        saveAs(blob, saveName);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    // 导入费用
    importLogistics(array) {
      console.log(array, '导入费用');
      const arrData = array[0].results.splice(2);
      const header = array[0].header;
      const column = [
        '车辆类型', '应付主体', '车线名称', '运输类型'
      ];
      try {
        const allData = [];
        // 初始化
        arrData.forEach((item, index) => {
          const data = {};
          header.map(list => {
            data[list] = (item[list] !== '' && item[list] !== null && item[list] !== undefined) ? item[list] : '';
          });
          allData.push(data);
        });
        // console.log(allData, 'allData');
        const dataArr = [];
        allData.forEach((item) => {
          const data = {};
          Object.keys(item).forEach((key, index) => {
            // console.log(key, 'key', index, item[key]);
            // 需要映射的key
            if (column.includes(key)) {
              data[columns[index].key] = item[key] ? item[key].split('->')[1] : '';
            } else {
              data[columns[index].key] = item[key];
            }
          });
          dataArr.push(data);
        });
        this.$emit('importPrice', dataArr);
      } catch (error) {
        console.log(error);
        this.$message.error(`【'车辆类型', '应付主体', '车线名称', '运输类型'】 ${this.$t('receivablePayable.dataError')}`);
      }
    }
  }
};
</script>
